<template>
    <div class="partner">
        <div class="business-summary">
            <div class="business-card sales-card">
                <div class="business-icon"><img class="business-icon-svg sales-icon-svg" :src="salesIcon" alt="SPU数量" />
                </div>
                <div class="business-content">
                    <div class="business-value">{{ goodsCount.spuCount ?? '-' }}</div>
                    <div class="business-label">SPU数量</div>
                </div>
            </div>
            <div class="business-card cost-card">
                <div class="business-icon"><img class="business-icon-svg cost-icon-svg" :src="costIcon" alt="SKU数量" />
                </div>
                <div class="business-content">
                    <div class="business-value">{{ goodsCount.skuCount ?? '-' }}</div>
                    <div class="business-label">SKU数量</div>
                </div>
            </div>
        </div>
        <div>
            <div class="header_btn" @keyup.enter="searchBtn">
                <el-input class="common_ipt" v-model="filters.keyword" placeholder="请输入商品名称" clearable />
                <el-input class="common_ipt" v-model="filters.spuId" placeholder="请输入SPU ID" clearable />
                <el-input class="common_ipt" v-model="filters.skuId" placeholder="请输入SKU ID" clearable />
                <el-input class="common_ipt" v-model="filters.brand" placeholder="请输入品牌名称" clearable />
                <el-input class="common_ipt category-selector" :model-value="selectedCategoryNames" placeholder="请选择合作方类目"
                    readonly @click="openCategoryDialog" @keydown.enter.stop="openCategoryDialog" @keydown.space.prevent="openCategoryDialog">
                    <template #suffix>
                        <el-icon v-if="filters.partnerCategoryIds.length" class="category-clear" @click.stop="clearCategories"><CircleClose /></el-icon>
                        <el-icon @click.stop="openCategoryDialog"><ArrowDown /></el-icon>
                    </template>
                </el-input>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPricingGrossMarginRate" placeholder="最低毛利率（%）" aria-label="最低毛利率（%）" clearable
                        @input="value => sanitizeDecimal('minPricingGrossMarginRate', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPricingGrossMarginRate" placeholder="最高毛利率（%）" aria-label="最高毛利率（%）" clearable
                        @input="value => sanitizeDecimal('maxPricingGrossMarginRate', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPricingGrossProfitAmount" placeholder="最低毛利额（元）" aria-label="最低毛利额（元）" clearable @input="value => sanitizeDecimal('minPricingGrossProfitAmount', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPricingGrossProfitAmount" placeholder="最高毛利额（元）" aria-label="最高毛利额（元）" clearable @input="value => sanitizeDecimal('maxPricingGrossProfitAmount', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPlatformSalePrice" placeholder="最低平台售价" aria-label="最低平台售价" clearable @input="value => sanitizeDecimal('minPlatformSalePrice', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPlatformSalePrice" placeholder="最高平台售价" aria-label="最高平台售价" clearable @input="value => sanitizeDecimal('maxPlatformSalePrice', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPurchasePrice" placeholder="最低采购价" aria-label="最低采购价" clearable @input="value => sanitizeDecimal('minPurchasePrice', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPurchasePrice" placeholder="最高采购价" aria-label="最高采购价" clearable @input="value => sanitizeDecimal('maxPurchasePrice', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minRecommendedPrice" placeholder="最低原始推荐价" aria-label="最低原始推荐价" clearable @input="value => sanitizeDecimal('minRecommendedPrice', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxRecommendedPrice" placeholder="最高原始推荐价" aria-label="最高原始推荐价" clearable @input="value => sanitizeDecimal('maxRecommendedPrice', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPriceAdjustRate" placeholder="最低推荐价差（%）" aria-label="最低推荐价差（%）" clearable @input="value => sanitizeDecimal('minPriceAdjustRate', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPriceAdjustRate" placeholder="最高推荐价差（%）" aria-label="最高推荐价差（%）" clearable @input="value => sanitizeDecimal('maxPriceAdjustRate', value)" />
                </div>
                <div class="margin-rate-range">
                    <el-input v-model="filters.minPriceAdjustAmount" placeholder="最低推荐价差（元）" aria-label="最低推荐价差（元）" clearable @input="value => sanitizeDecimal('minPriceAdjustAmount', value)" />
                    <span class="range-separator">-</span>
                    <el-input v-model="filters.maxPriceAdjustAmount" placeholder="最高推荐价差（元）" aria-label="最高推荐价差（元）" clearable @input="value => sanitizeDecimal('maxPriceAdjustAmount', value)" />
                </div>
                <el-select class="force-style-input" v-model="priceAdjustDirectionsSelection" placeholder="请选择价格方向" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="高于推荐价" value="UP" />
                    <el-option label="低于推荐价" value="DOWN" />
                    <el-option label="等于推荐价" value="FLAT" />
                    <el-option label="未知" value="UNKNOWN" />
                </el-select>
                <el-select class="force-style-input" v-model="inventoryTypesSelection" placeholder="请选择库存类型" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="数量库存" value="QUANTITY" />
                    <el-option label="不限库存" value="UNLIMITED" />
                    <el-option label="需地址查询" value="ADDRESS_REQUIRED" />
                    <el-option label="库存未知" value="UNKNOWN" />
                </el-select>
                <el-select class="force-style-input" v-model="availabilityStatusesSelection" placeholder="请选择库存状态" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="有货" value="IN_STOCK" />
                    <el-option label="无货" value="OUT_OF_STOCK" />
                    <el-option label="未知" value="UNKNOWN" />
                </el-select>
                <el-select class="force-style-input" v-model="filters.sortField" placeholder="请选择排序方式" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="SPU ID" value="spuId" />
                    <el-option label="商品名称" value="name" />
                    <el-option label="最低售价" value="minPlatformSalePrice" />
                    <el-option label="最低采购价" value="minPurchasePrice" />
                    <el-option label="最低预估毛利率" value="minPricingGrossMarginRate" />
                    <el-option label="源更新时间" value="sourceUpdatedAt" />
                    <el-option label="已知库存合计" value="knownInventory" />
                </el-select>
                <el-select class="force-style-input" v-model="filters.sortOrder" placeholder="请选择排序方向" size="large" clearable
                    style="width: 220px;margin-right: 10px;">
                    <el-option label="升序" value="asc" />
                    <el-option label="降序" value="desc" />
                </el-select>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="源更新开始时间"
                    end-placeholder="源更新结束时间" size="large" style="width: 400;margin:0 10px 10px 0;" clearable :disabled-date="disabledDate" />

                <el-button size="large" style="margin:0 0 10px 0;" @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="showLoading"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
        </div>
        <div class="summation">
            <div class="hint">统计 : {{ count }}条</div>
        </div>

        <el-table ref="tableRef" class="manage-list-table" :data="filterTableData" style="width: 100%" :fit="true"
            row-key="spuId" border :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts" v-loading="showLoading" @expand-change="handleSkuExpand">
            <el-table-column type="expand" fixed="left" width="50">
                <template #default="{ row }">
                    <div class="sku-table-container" :class="{ 'is-preparing': !skuStates[row.spuId]?.ready }"
                        :style="{ width: skuTableWidth ? `${skuTableWidth}px` : '100%' }" v-loading="!skuStates[row.spuId]?.ready">
                        <el-table v-if="skuStates[row.spuId] && !skuStates[row.spuId].loading"
                            :ref="el => setSkuTableRef(row.spuId, el)" :class="{ 'sku-table-preparing': !skuStates[row.spuId].ready }"
                            :data="skuStates[row.spuId].data" row-key="skuId" border style="width: 100%"
                            :max-height="420" scrollbar-always-on
                            :header-cell-style="{ background: '#F5F7FA' }" :empty-text="skuStates[row.spuId]?.error || texts">
                            <el-table-column label="SKU ID" prop="skuId" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="商品图片" prop="image" align="center" min-width="150">
                                <template #default="{ row: sku }">
                                    <el-image v-if="sku.image" class="table-td-thumb" :src="sku.image" :preview-src-list="[sku.image]" :preview-teleported="true" />
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格" prop="attrs" :formatter="formatSkuAttrs" align="center" :show-overflow-tooltip="true" min-width="250" />
                            <el-table-column label="线上售价" prop="platformSalePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="划线价" prop="displayMarketPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="售价积分" prop="points" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="采购成本" prop="purchasePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="原始推荐价" prop="recommendedPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="预估运费" prop="estimatedFreightCost" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="计价成本" prop="pricingCostPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="采购预估毛利额" prop="goodsGrossProfitAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="采购预估毛利率" prop="goodsGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="计价预估毛利额" prop="pricingGrossProfitAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="计价预估毛利率" prop="pricingGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="推荐价差（元）" prop="priceAdjustAmount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="推荐价差（%）" prop="priceAdjustRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="价格对比" prop="priceAdjustDirection" :formatter="formatPriceAdjustDirection" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="目标毛利" prop="targetGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="规则来源" prop="pricingRuleSource" :formatter="formatPricingRuleSource" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="库存数量" prop="availableQuantity" :formatter="formatAvailableQuantity" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="可售状态" prop="availabilityStatus" :formatter="formatAvailabilityStatus" align="center" :show-overflow-tooltip="true" min-width="180" />
                            <el-table-column label="源数据更新时间" prop="sourceUpdatedAt" :formatter="formatMillisecondsTime" align="center" :show-overflow-tooltip="true" min-width="180" />
                        </el-table>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="合作方编码" prop="partnerCode" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="spuId" prop="spuId" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="商品名称" prop="name" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="220" />
            <el-table-column label="商品图片" prop="mainImage" align="center" min-width="150">
                <template #default="{ row }">
                    <el-image v-if="row.mainImage" class="table-td-thumb" :src="row.mainImage" :preview-src-list="[row.mainImage]" :preview-teleported="true" />
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="品牌名称" prop="brand" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="平台类目" align="center" :show-overflow-tooltip="true" min-width="220">
                <template #default="{ row }">{{ formatCategoryPath([row.platformFirstLevelCategoryName, row.platformSecondLevelCategoryName]) }}</template>
            </el-table-column>
            <el-table-column label="合作方类目" align="center" :show-overflow-tooltip="true" min-width="220">
                <template #default="{ row }">{{ formatCategoryPath([row.partnerFirstLevelCategoryName, row.partnerSecondLevelCategoryName, row.partnerThirdLevelCategoryName]) }}</template>
            </el-table-column>
            <el-table-column label="适用性别" prop="applicableGender" :formatter="formatGender" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="线上搜索" prop="isSearch" :formatter="formatSearchStatus" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="SKU数量" prop="skuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="匹配SKU数量" prop="matchedSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低价SKU ID" prop="summaryPriceSkuId" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低平台售价" prop="minPlatformSalePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最高平台售价" prop="maxPlatformSalePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低采购价" prop="minPurchasePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最高采购价" prop="maxPurchasePrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低原始推荐价" prop="minRecommendedPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最高原始推荐价" prop="maxRecommendedPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低计价成本" prop="minPricingCostPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最高计价成本" prop="maxPricingCostPrice" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最低毛利率（%）" prop="minPricingGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="最高毛利率（%）" prop="maxPricingGrossMarginRate" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="有限库存合计" prop="knownInventory" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="无限库存SKU数量" prop="unlimitedSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="地址查询SKU数量" prop="unknownStockSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="上浮SKU数量" prop="upSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="下浮SKU数量" prop="downSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="持平SKU数量" prop="flatSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="不可比SKU数量" prop="unknownPriceSkuCount" :formatter="formatEmptyValue" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column label="源更新时间" prop="sourceUpdatedAt" :formatter="formatMillisecondsTime" align="center" :show-overflow-tooltip="true" min-width="180" />
            <el-table-column fixed="right" label="操作" align="center" min-width="200">
                <template #default="{ row }">
                    <el-button class="bulur" size="default" @click="handleSpuDetail(row)"><el-icon class="cancel"><Search /></el-icon>查看SPU详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 10, 15, 20]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />

        <SpuDetailDrawer ref="spuDetailRef" />

        <el-dialog v-model="categoryDialogVisible" title="合作方类目" width="500px" top="10vh"
            custom-class="category-dialog" @opened="initializeCategoryTree">
            <el-input v-model="categoryKeyword" placeholder="请输入类目名称关键字" clearable />
            <div class="category-tree-container">
                <el-tree ref="categoryTreeRef" :data="categoryTreeData" node-key="categoryId"
                    :props="{ label: 'categoryName', children: 'children' }" show-checkbox check-strictly
                    :filter-node-method="filterCategoryNode" :expand-on-click-node="false" />
            </div>
            <template #footer>
                <el-button @click="categoryDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmCategories">确定</el-button>
            </template>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: 'jingdongGoods'
}
</script>

<script setup>
import { ArrowDown, CircleClose, Search } from '@element-plus/icons-vue';
import { computed, nextTick, onActivated, onBeforeUnmount, reactive, ref, onMounted, watch } from 'vue';
import moments from 'moment';
import { ElMessage } from 'element-plus';
import { queryJingdongGoodsList, jingdongCategoryTreeList, queryJingDongGoodsCount, queryGoodsSkuList } from '../../../request/api';
import SpuDetailDrawer from './SpuDetailDrawer.vue';
import { onBeforeRouteLeave } from 'vue-router';
import costIcon from './svg/sku.svg';
import salesIcon from './svg/spu.svg';

const createDefaultFilters = () => ({
    "keyword": "",
    "spuId": "",
    "skuId": "",
    "brand": "",
    "partnerCategoryIds": [],
    "minPricingGrossMarginRate": "",
    "maxPricingGrossMarginRate": "",
    "minPricingGrossProfitAmount": "",
    "maxPricingGrossProfitAmount": "",
    "minPlatformSalePrice": "",
    "maxPlatformSalePrice": "",
    "minPurchasePrice": "",
    "maxPurchasePrice": "",
    "minRecommendedPrice": "",
    "maxRecommendedPrice": "",
    "minPriceAdjustRate": "",
    "maxPriceAdjustRate": "",
    "minPriceAdjustAmount": "",
    "maxPriceAdjustAmount": "",
    "priceAdjustDirections": [],
    "inventoryTypes": [],
    "availabilityStatuses": [],
    "sortField": "",
    "sortOrder": ""
});
const filters = reactive(createDefaultFilters());
// Single-select controls retain array values in the query filters.
const createSingleArraySelection = field => computed({
    get: () => filters[field][0] ?? '',
    set: value => {
        filters[field] = value ? [value] : [];
    }
});
const priceAdjustDirectionsSelection = createSingleArraySelection('priceAdjustDirections');
const inventoryTypesSelection = createSingleArraySelection('inventoryTypes');
const availabilityStatusesSelection = createSingleArraySelection('availabilityStatuses');

const numberFields = ["minPricingGrossMarginRate", "maxPricingGrossMarginRate", "minPricingGrossProfitAmount", "maxPricingGrossProfitAmount", "minPlatformSalePrice", "maxPlatformSalePrice", "minPurchasePrice", "maxPurchasePrice", "minRecommendedPrice", "maxRecommendedPrice"];
const time = ref([]);
const categoryTreeData = ref([]);
const categoryTreeRef = ref(null);
const categoryDialogVisible = ref(false);
const categoryKeyword = ref('');
const categoryNamesById = computed(() => {
    const names = new Map();
    const visit = nodes => nodes.forEach(node => {
        names.set(node.categoryId, node.categoryName);
        visit(node.children || []);
    });
    visit(categoryTreeData.value);
    return names;
});
const selectedCategoryNames = computed(() => filters.partnerCategoryIds
    .map(id => categoryNamesById.value.get(id) || String(id)).join('、'));
const filterCategoryNode = (keyword, data) => !keyword.trim() ||
    String(data.categoryName || '').toLowerCase().includes(keyword.trim().toLowerCase());
watch(categoryKeyword, value => categoryTreeRef.value?.filter(value));
const initializeCategoryTree = () => {
    categoryTreeRef.value?.setCheckedKeys([...filters.partnerCategoryIds]);
    categoryTreeRef.value?.filter(categoryKeyword.value);
    if (!filters.partnerCategoryIds.length) {
        const collapseNodes = nodes => nodes.forEach(node => {
            categoryTreeRef.value?.getNode(node.categoryId)?.collapse();
            collapseNodes(node.children || []);
        });
        collapseNodes(categoryTreeData.value);
    }
};
const openCategoryDialog = () => {
    categoryKeyword.value = '';
    categoryDialogVisible.value = true;
};
const clearCategories = event => {
    event?.stopPropagation?.();
    filters.partnerCategoryIds = [];
    categoryTreeRef.value?.setCheckedKeys([]);
};
const confirmCategories = () => {
    filters.partnerCategoryIds = categoryTreeRef.value?.getCheckedKeys() || [];
    categoryDialogVisible.value = false;
};
const texts = ref('暂无数据');
const currentPage = ref(1);
const pagesize = ref(6);
const filterTableData = ref([]);
const goodsCount = ref({ spuCount: null, skuCount: null });
const partnerCode = ref('');
const skuStates = reactive({});
const skuTableRefs = new Map();
const setSkuTableRef = (spuId, table) => {
    if (table) skuTableRefs.set(spuId, table);
    else skuTableRefs.delete(spuId);
};
const count = ref(0);
const showLoading = ref(false);
const tableRef = ref(null);
const tableScrollLeft = ref(0);
const skuTableWidth = ref(0);
let tableResizeObserver;
const updateSkuTableWidth = () => {
    const width = tableRef.value?.$el?.clientWidth;
    if (width) skuTableWidth.value = width;
};

const refreshTableLayout = () => {
    nextTick(() => {
        tableRef.value?.doLayout?.();
        updateSkuTableWidth();
    });
};

const getTableScrollWrap = () =>
    tableRef.value?.scrollBarRef?.wrapRef ||
    tableRef.value?.$el?.querySelector?.('.el-scrollbar__wrap');

const saveTableScrollPosition = () => {
    const scrollWrap = getTableScrollWrap();
    if (scrollWrap) tableScrollLeft.value = scrollWrap.scrollLeft;
};

const restoreTableScrollPosition = () => {
    nextTick(() => {
        tableRef.value?.doLayout?.();
        window.requestAnimationFrame(() => {
            tableRef.value?.setScrollLeft?.(tableScrollLeft.value);
            window.requestAnimationFrame(() => {
                tableRef.value?.setScrollLeft?.(tableScrollLeft.value);
            });
        });
    });
};

const isEmptyValue = (value) => value === null || value === undefined || value === '';

const formatEmptyValue = (row, column, cellValue) => {
    return isEmptyValue(cellValue) ? '-' : cellValue;
};

const formatMillisecondsTime = (row, column, cellValue) => {
    return isEmptyValue(cellValue) ? '-' : moments(Number(cellValue)).format('YYYY-MM-DD HH:mm:ss');
};


const sanitizeDecimal = (field, value) => {
    const cleaned = String(value).replace(/[^0-9.]/g, '');
    const dot = cleaned.indexOf('.');
    filters[field] = dot < 0 ? cleaned : cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
};
const formatCategoryPath = values => values.filter(value => !isEmptyValue(value)).join('/') || '-';
const formatGender = (row, column, value) => {
    if (isEmptyValue(value)) return '未设置';
    return ({ male: '男', female: '女', unisex: '男女通用', kids: '儿童', unknown: '未知' })[value] || '未知';
};
const formatSearchStatus = (row, column, value) =>
    ({ 1: '允许', 2: '不允许' })[value] || '-';

const getGoodsQueryParams = () => {
    const params = { ...filters };
    numberFields.forEach(field => {
        params[field] = filters[field] === '' || filters[field] === '.' ? null : Number(filters[field]);
    });
    params.minSourceUpdatedAt = time.value?.length === 2 ? moments(time.value[0]).startOf('day').valueOf() : null;
    params.maxSourceUpdatedAt = time.value?.length === 2 ? moments(time.value[1]).endOf('day').valueOf() : null;
    params.pageNum = Number(currentPage.value);
    params.pageSize = Number(pagesize.value);
    return params;
};

const formatSkuAttrs = (row, column, value) => {
    if (isEmptyValue(value)) return '-';
    if (typeof value !== 'object') return String(value);
    return Object.entries(value).filter(([, item]) => !isEmptyValue(item))
        .map(([key, item]) => `${key}：${typeof item === 'object' ? JSON.stringify(item) : item}`)
        .join(' / ') || '-';
};
const formatPriceAdjustDirection = (row, column, value) =>
    ({ UP: '高于推荐价', DOWN: '低于推荐价', FLAT: '等于推荐价', UNKN: '不可比' })[value] || '-';
const formatPricingRuleSource = (row, column, value) =>
    ({ CATEGORY: '当前类目', PARENT_CATEGORY: '上级类目', FALLBACK: '兜底规则' })[value] || '-';
const formatAvailableQuantity = (row, column, value) =>
    isEmptyValue(value) || Number(value) === 0 ? '未知' : value;
const formatAvailabilityStatus = (row, column, value) =>
    ({ IN_STOCK: '有货', OUT_OF_STOCK: '缺货', UNKNOWN: '未知' })[value] || '-';

const spuDetailRef = ref(null);
const handleSpuDetail = (row) => {
    const code = isEmptyValue(row.partnerCode) ? partnerCode.value : row.partnerCode;
    if (isEmptyValue(code) || isEmptyValue(row.spuId)) {
        ElMessage.error('合作方编码或SPU ID未获取，请重新查询后查看');
        return;
    }
    spuDetailRef.value?.open({ partnerCode: code, spuId: row.spuId });
};

const handleSkuExpand = async (row, expandedRows) => {
    if (!expandedRows.some(item => item.spuId === row.spuId)) return;
    updateSkuTableWidth();
    const state = reactive({ loading: true, ready: false, data: [], error: '' });
    skuStates[row.spuId] = state;
    try {
        if (isEmptyValue(partnerCode.value)) {
            state.error = '合作方编码未获取，请重新查询后展开';
            ElMessage.error(state.error);
            return;
        }
        const res = await queryGoodsSkuList({ partnerCode: partnerCode.value, spuId: row.spuId });
        if (skuStates[row.spuId] !== state) return;
        if (res.data.code == 0) {
            const skuList = res.data.data?.data;
            state.data = Array.isArray(skuList) ? skuList : [];
        } else {
            state.error = res.data.msg || 'SKU列表加载失败';
            ElMessage.error(state.error);
        }
    } catch (error) {
        if (skuStates[row.spuId] !== state) return;
        state.error = 'SKU列表加载失败，请收起后重新展开';
        ElMessage.error(state.error);
    } finally {
        if (skuStates[row.spuId] === state) {
            state.loading = false;
            await nextTick();
            // 子表挂载并计算列宽、滚动条后再显示，避免宽表的初始布局闪现。
            window.requestAnimationFrame(() => {
                if (skuStates[row.spuId] !== state) return;
                skuTableRefs.get(row.spuId)?.doLayout?.();
                window.requestAnimationFrame(() => {
                    if (skuStates[row.spuId] === state) state.ready = true;
                });
            });
        }
    }
};

let latestRequest = 0;
const dataInfo = async () => {
    const requestId = ++latestRequest;
    filterTableData.value.forEach(row => tableRef.value?.toggleRowExpansion(row, false));
    Object.keys(skuStates).forEach(key => delete skuStates[key]);
    const params = getGoodsQueryParams();
    const countParams = { ...params };
    delete countParams.pageNum;
    delete countParams.pageSize;
    showLoading.value = true;
    goodsCount.value = { spuCount: null, skuCount: null };
    try {
        const [listResult, countResult] = await Promise.allSettled([
            queryJingdongGoodsList(params),
            queryJingDongGoodsCount(countParams)
        ]);
        if (requestId !== latestRequest) return;
        if (listResult.status === 'fulfilled') {
            const res = listResult.value;
            if (res.data.code == 0) {
                filterTableData.value = res.data.data.data || [];
                count.value = res.data.data.total;
            } else {
                ElMessage.error(res.data.msg);
            }
        } else {
            ElMessage.error('商品列表加载失败');
        }
        if (countResult.status === 'fulfilled') {
            const res = countResult.value;
            if (res.data.code == 0) {
                const data = res.data.data || {};
                partnerCode.value = data.partnerCode ?? '';
                goodsCount.value = {
                    spuCount: isEmptyValue(data.spuCount) ? null : data.spuCount,
                    skuCount: isEmptyValue(data.skuCount) ? null : data.skuCount
                };
            } else {
                ElMessage.error(res.data.msg);
            }
        } else {
            ElMessage.error('商品数量统计加载失败');
        }
    } catch (error) {
        if (requestId === latestRequest) ElMessage.error('商品列表加载失败');
    } finally {
        if (requestId === latestRequest) showLoading.value = false;
    }
};
const getCategoryTreeList = async () => {
    try {
        const res = await jingdongCategoryTreeList();
        if (res.data.code == 0) {
            categoryTreeData.value = Array.isArray(res.data.data) ? res.data.data : [];
            if (categoryDialogVisible.value) await nextTick(initializeCategoryTree);
        } else {
            ElMessage.error(res.data.msg);
        }
    } catch (error) {
        ElMessage.error('合作方类目加载失败');
    }
};
const disabledDate = date => date.getTime() > Date.now();
const searchBtn = () => {
    currentPage.value = 1;
    dataInfo();
};
const resetBtn = () => {
    Object.assign(filters, createDefaultFilters());
    categoryKeyword.value = '';
    categoryTreeRef.value?.setCheckedKeys([]);
    time.value = [];
    currentPage.value = 1;
    pagesize.value = 6;
    dataInfo();
};
const handleSizeChange = value => {
    pagesize.value = value;
    currentPage.value = 1;
    dataInfo();
};
const handleCurrentChange = value => {
    currentPage.value = value;
    dataInfo();
};
onMounted(() => {
    getCategoryTreeList();
    dataInfo();
    window.addEventListener('resize', refreshTableLayout);
    nextTick(() => {
        updateSkuTableWidth();
        if (tableRef.value?.$el) {
            tableResizeObserver = new ResizeObserver(updateSkuTableWidth);
            tableResizeObserver.observe(tableRef.value.$el);
        }
    });
});
onBeforeUnmount(() => {
    window.removeEventListener('resize', refreshTableLayout);
    tableResizeObserver?.disconnect();
});
onActivated(restoreTableScrollPosition);
onBeforeRouteLeave(saveTableScrollPosition);
</script>

<style lang="scss" scoped>
.sku-table-container {
    position: sticky;
    left: 0;
    box-sizing: border-box;
    // padding: 10px 20px;
    min-width: 0;
}

.sku-table-container.is-preparing {
    min-height: 120px;
}

.sku-table-preparing {
    visibility: hidden;
}

.manage-list-table :deep(td.el-table__expanded-cell) {
    padding: 10px 0;
}

.margin-rate-range {
    display: inline-flex;
    align-items: center;
    width: 300px;
    max-width: 100%;
    height: 40px;
    box-sizing: border-box;
    margin: 0 10px 10px 0;
    border: 1px solid var(--el-input-border-color, var(--el-border-color-base, #dcdfe6));
    border-radius: var(--el-input-border-radius, 4px);
    background: var(--el-input-bg-color, #fff);
    transition: border-color 0.2s;

    &:hover {
        border-color: var(--el-border-color-hover, #c0c4cc);
    }

    &:focus-within {
        border-color: var(--el-color-primary, #409eff);
    }

    .range-separator {
        flex: 0 0 20px;
        text-align: center;
        color: var(--el-text-color-primary, #303133);
    }
}

.margin-rate-range :deep(.el-input) {
    flex: 1;
    min-width: 0;
}

.margin-rate-range :deep(.el-input__inner) {
    height: 38px;
    border: none;
    background: transparent;
    box-shadow: none;
    text-align: center;
}

.margin-rate-range :deep(.el-input__wrapper) {
    background: transparent;
    box-shadow: none;
}

.category-selector {
    cursor: pointer;
}

::v-deep .category-selector .el-input__suffix,
::v-deep .category-selector .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
}

.category-clear {
    margin-right: 6px;
}

.category-tree-container {
    height: 50vh;
    overflow: auto;
    margin-top: 15px;
}

::v-deep .table-td-thumb {
    width: 60px;
    height: 36px;
    vertical-align: middle;
}

::v-deep .table-td-thumb .el-image__inner {
    object-fit: cover;
}

/* 修复展开箭头动画 */
::v-deep .el-table__expand-icon {
    transition: transform 0.3s;

    &.el-table__expand-icon--expanded {
        transform: rotate(90deg);
    }
}

/* 确保展开内容区域样式 */
::v-deep .el-table__expanded-cell {
    // padding: 10px !important;
    //   background-color: #fafafa;

    .el-table {
        // margin: 10px 0;
    }
}

::v-deep .el-input__inner {
    height: 40px;
}

/* 与 allocating 页面保持一致的表格表头及行高 */
::v-deep .el-table__header {
    margin: 0 !important;
}

::v-deep .el-table .el-table__cell {
    padding-top: 15px;
    padding-bottom: 15px;
}

.el-pagination {
    margin-top: 10px;
}

.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.cancel {
    margin-right: 5px;
    font-weight: 400;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.business-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 98%;
    gap: 10px;
    margin: 0 0 20px 0;
}

.business-card {
    display: flex;
    height: 100px;
    min-width: 0;
    overflow: hidden;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.business-icon {
    display: grid;
    flex: 0 0 100px;
    place-items: center;
    color: #fff;
    font-size: 30px;
}

.business-icon-svg {
    display: block;
    width: 42px;
    height: 42px;
    object-fit: contain;
}

.sales-icon-svg {
    filter: brightness(0) invert(1);
}

.cost-icon-svg {
    filter: brightness(0) invert(1);
}

.business-content {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
}

.business-value {
    max-width: 100%;
    overflow: hidden;
    font-size: 25px;
    font-weight: 600;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.business-label {
    color: #909399;
    font-size: 14px;
    line-height: 22px;
}

.sales-card .business-icon {
    background: #ff7b31;
}

.sales-card .business-value {
    color: #ff7b31;
}

.cost-card .business-icon {
    background: #1b8ffb;
}

.cost-card .business-value {
    color: #1b8ffb;
}

@media (max-width: 1200px) {
    .business-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .business-summary {
        grid-template-columns: 1fr;
    }

    .business-icon {
        flex-basis: 72px;
    }
}


.summation {
    display: flex;
    justify-content: space-between;
}

.hint {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}

.header_btn {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.common_ipt {
    width: 220px;
    height: 40px !important;
    margin-right: 10px;
    margin-bottom: 10px;
}

.common_ipt3 {
    width: 220px;
}

.force-style-input {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
}
</style>
